import { inView, animate } from 'motion';

$('.int-timeline-event__content .read-more').click((e) => {
  $(e.target).parent().addClass('is-showing');
});

// Build years anchors
const dates = [];
document.querySelectorAll('.type-datebreak h2').forEach((item) => {
  const data = {
    year: item.innerHTML,
    pos: item.getBoundingClientRect().top + window.scrollY - 100,
  };
  dates.push(data);
});

const datesWrapper = document.querySelector('.int-timeline-nav');
dates.forEach((item) => {
  datesWrapper.innerHTML += `<a href="#scroll-${item.year}" data-pos="${item.pos}">${item.year}</a>`;
});

const dateEls = document.querySelectorAll('.int-timeline-nav a');
document.onscroll = () => {
  const scrollTop = window.scrollY;

  // Toggle dates navigation on scroll
  const intTimelineEl = document.querySelector('.int-timeline');
  if (!intTimelineEl) return;
  const timelinePos = intTimelineEl.getBoundingClientRect().top + window.innerHeight / 4;
  const footerTopEl = document.querySelector('.footer-top');
  if (!footerTopEl) return;
  const timelinePosBot = footerTopEl.getBoundingClientRect().top - window.innerHeight / 1.5;

  if (scrollTop < timelinePos || timelinePosBot < 0) {
    datesWrapper.classList.remove('visible');
  } else {
    datesWrapper.classList.add('visible');
  }

  // Dates highlight on scroll
  dateEls.forEach((item) => {
    if (scrollTop > item.dataset.pos) item.classList.add('visible');
    else item.classList.remove('visible');
  });
};

// Animation
const allEventSections = document.querySelectorAll('.int-timeline > .int-timeline__events > .int-timeline-event');

function checkCollapseToggles() {
  allEventSections.forEach((el) => {
    const collapseElWrapper = el.querySelector('.int-timeline-event__content');
    if (!collapseElWrapper) return;
    const collapseEl = collapseElWrapper.querySelector('.int-timeline-event__content__text .text__collapse-size');
    if (!collapseEl) return;
    if (collapseEl.getBoundingClientRect().height <= 200) collapseElWrapper.classList.add('is-showing');
  });
}

checkCollapseToggles(); // Check to remove 'Read more' buttons on timeline init if a text section is small;

inView(
  allEventSections,
  (target) => {
    const viewportWidth = window.innerWidth;

    if (target.classList.contains('type-datebreak')) {
      animate(target.querySelector('h2'), { opacity: 1 }, { delay: 0.4, duration: 0.5, easing: 'ease-in-out' });
    } else if (target.classList.contains('type-video')) {
      animate(target, { transform: 'translate(0,0)', opacity: 1 }, { delay: 0.4, duration: 0.5, easing: 'ease-in-out' });
      setTimeout(() => target.querySelector('.int-timeline-event__marker')?.classList.add('visible'), 500); // Additional CSS animation
    } else if (target.classList.contains('type-quote')) {
      const sequence = [];
      const markerEl = target.querySelector('.int-timeline-event__marker');
      if (markerEl) sequence.push([markerEl, { transform: 'translate(0,0)' }, { delay: 0.4, duration: 0.5, easing: 'ease-in-out' }]);
      const contentEl = target.querySelector('.int-timeline-event__content');
      if (contentEl) sequence.push([contentEl, { transform: 'translate(0,0)', opacity: 1 }, { duration: 0.5, at: +0.4 }]);
      setTimeout(() => target.querySelector('.int-timeline-event__marker')?.classList.add('visible'), 500); // Additional CSS animation
      animate(sequence);
    } else {
      const sequence = [];
      const markerEl = target.querySelector('.int-timeline-event__marker');
      if (markerEl) sequence.push([markerEl, { transform: 'translate(0,0)' }, { delay: 0.4, duration: 0.5, easing: 'ease-in-out' }]);
      const contentEl = target.querySelector('.int-timeline-event__content');
      if (contentEl) sequence.push([contentEl, { transform: 'translate(0,0)', opacity: 1 }, { duration: 0.5, at: +0.4 }]);
      const contentCtaEl = target.querySelector('.int-timeline-event__content .bnt.int-timeline-event__content__cta');
      if (contentCtaEl) sequence.push([contentCtaEl, { opacity: 1 }, { duration: 0.5, at: +1 }]);
      const imageEl = target.querySelector('.int-timeline-event__image');
      if (imageEl) sequence.push([imageEl, { transform: 'translate(0,0)', opacity: 1 }, { duration: 0.5, at: viewportWidth <= 768 ? +1 : '<' }]);
      setTimeout(() => target.querySelector('.int-timeline-event__marker')?.classList.add('visible'), 500); // Additional CSS animation
      animate(sequence);
    }
  },
  { margin: '-200px 0px 0px 0px' }
);
